import axios from 'axios';

// const API_BASE_URL = 'http://localhost/formatally';
// const API_BASE_URL = 'https://formatally.com/backend/';
// const API_BASE_URL = 'http://appadmin.dskview.com/formatally/';
const API_BASE_URL = 'https://formatally.dskcode.com/formatally/';



// Create axios instance with default config
const apiClient = axios.create({
    baseURL: API_BASE_URL,
    timeout: 10000, // 10 seconds timeout
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// Request interceptor
apiClient.interceptors.request.use(
    (config) => {
        console.log(`🚀 Making ${config.method?.toUpperCase()} request to:`, config.url);
        console.log('📤 Request data:', config.data);
        return config;
    },
    (error) => {
        console.error('❌ Request error:', error);
        return Promise.reject(error);
    }
);

// Response interceptor
apiClient.interceptors.response.use(
    (response) => {
        console.log('✅ Response received:', response.data);
        return response.data; // Return only the data part
    },
    (error) => {
        console.error('❌ Response error:', error);
        
        // Handle different error types
        if (error.response) {
            // Server responded with error status
            const message = error.response.data?.message || 'Server error occurred';
            throw new Error(message);
        } else if (error.request) {
            // Request was made but no response received
            throw new Error('No response from server. Please check your connection.');
        } else {
            // Something else happened
            throw new Error(error.message || 'An unexpected error occurred');
        }
    }
);

class ApiService {
    // Feedback API
    async submitFeedback(feedbackData) {
        console.log('📝 Submitting feedback:', feedbackData);
        return apiClient.post('/feedback.php', feedbackData);
    }

    async getFeedbacks() {
        return apiClient.get('/feedback.php');
    }

    async getFeedbackById(id) {
        return apiClient.get(`/feedback.php?id=${id}`);
    }

    async deleteFeedback(id) {
        return apiClient.delete(`/feedback.php?id=${id}`);
    }

    // Newsletter API
    async subscribeNewsletter(email) {
        return apiClient.post('/newsletter.php', { email });
    }

    async unsubscribeNewsletter(email) {
        return apiClient.post('/newsletter.php?action=unsubscribe', { email });
    }

    async getSubscribers() {
        return apiClient.get('/newsletter.php');
    }

    async getSubscriberCount() {
        return apiClient.get('/newsletter.php?action=count');
    }

    async deleteSubscriber(email) {
        return apiClient.delete(`/newsletter.php?email=${email}`);
    }

    // Contact API - NEW METHODS
    async submitContact(contactData) {
        console.log('📞 Submitting contact:', contactData);
        return apiClient.post('/contact.php', contactData);
    }

    async getContacts(page = 1, limit = 50, status = null) {
        let url = `/contact.php?page=${page}&limit=${limit}`;
        if (status) {
            url += `&status=${status}`;
        }
        return apiClient.get(url);
    }

    async getContactById(id) {
        return apiClient.get(`/contact.php?id=${id}`);
    }

    async updateContactStatus(id, statusData) {
        return apiClient.put(`/contact.php?id=${id}`, statusData);
    }

    async deleteContact(id) {
        return apiClient.delete(`/contact.php?id=${id}`);
    }

    async getContactStats() {
        return apiClient.get('/contact.php?action=stats');
    }

    // User API
    async registerUser(userData) {
        return apiClient.post('/user.php?action=register', userData);
    }

    async loginUser(credentials) {
        return apiClient.post('/user.php?action=login', credentials);
    }

    async verifyEmail(token) {
        return apiClient.post('/user.php?action=verify', { token });
    }

    async forgotPassword(email) {
        return apiClient.post('/user.php?action=forgot-password', { email });
    }

    async resetPassword(token, password) {
        return apiClient.post('/user.php?action=reset-password', { token, password });
    }

    async getUsers() {
        return apiClient.get('/user.php');
    }

    async getUser(id) {
        return apiClient.get(`/user.php?id=${id}`);
    }

    async updateUser(id, userData) {
        return apiClient.put(`/user.php?id=${id}`, userData);
    }

    async deleteUser(id) {
        return apiClient.delete(`/user.php?id=${id}`);
    }

    // Visitors API
    async trackVisitor(visitorData) {
        return apiClient.post('/visitors.php', visitorData);
    }

    async getVisitors(page = 1, limit = 50) {
        return apiClient.get(`/visitors.php?page=${page}&limit=${limit}`);
    }

    async getVisitorStats() {
        return apiClient.get('/visitors.php?action=stats');
    }

    async getAnalytics(period = '7days') {
        return apiClient.get(`/visitors.php?action=analytics&period=${period}`);
    }

    async updateVisitorDuration(id, duration) {
        return apiClient.put(`/visitors.php?id=${id}`, { visit_duration: duration });
    }

    // Utility methods
    async testConnection() {
        try {
            const response = await apiClient.get('/config.php?health=1');
            return { success: true, message: 'API connection successful', data: response };
        } catch (error) {
            return { success: false, message: error.message };
        }
    }

    // Set authentication token
    setAuthToken(token) {
        if (token) {
            apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        } else {
            delete apiClient.defaults.headers.common['Authorization'];
        }
    }

    // Get current config
    getConfig() {
        return {
            baseURL: apiClient.defaults.baseURL,
            timeout: apiClient.defaults.timeout,
            headers: apiClient.defaults.headers,
        };
    }
}

export default new ApiService();